export default __webpack_public_path__ + "static/media/end-of-life.2a675079.png";